import { FC } from 'react';

import { BUTTON_BORDER_RADIUS, BUTTON_BOX_SHADOW } from '../modals/constants';

interface ModalButtonProps {
  close: () => void;
  color: string;
  text: string;
}

export const ModalButton: FC<ModalButtonProps> = ({ close, color, text }) => {
  return (
    <span
      onClick={close}
      style={{
        cursor: 'pointer',
        padding: '10px',
        backgroundColor: color,
        borderRadius: BUTTON_BORDER_RADIUS,
        boxShadow: BUTTON_BOX_SHADOW,
      }}
    >
      {text}
    </span>
  );
};
